export default __webpack_public_path__ + "e0ee089891c58e0e6e058e5fcadf9672.png";